import { useTranslation } from 'react-i18next';

import Radio from 'components/radio';

const MonthTypeSelector = ({ value, onChange }) => {
    const { t } = useTranslation('recurring');

    return (
        <div className="resource-repeat-row">
            <div className="row-label">
            </div>

            <div className="row-value">
                <div className="row-input">
                    <Radio
                        label="on date"
                        selected={value}
                        value="day"
                        onChange={onChange}
                    />
                </div>

                <div className="row-input">
                    <Radio
                        label="by week"
                        selected={value}
                        value="week"
                        onChange={onChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default MonthTypeSelector;
